import { MotionScale as motionComponent, Scale as component } from './component'
import { connect } from 'react-redux'
import { ComponentProps } from 'react'
import { AppState } from 'stores/index'

function mapStateToProps({
  extents,
  overallExtents
}: AppState): ComponentProps<typeof component> {
  return {
    minimum: extents[0] !== undefined ? extents[0] : 0,
    maximum: extents[1] !== undefined ? extents[1] : 15,
    overallMinimum: overallExtents[0],
    overallMaximum: overallExtents[1]
  }
}

export const MotionScale = connect(mapStateToProps)(motionComponent)

export const Scale = connect(mapStateToProps)(component)
